import { Navigate, Route, Routes } from "react-router-dom";
import App from "./App";
import Demo from "./Demo";
import Docs from "./Docs";
import Marketplace from "./Marketplace";
import Playground from "./Playground";
import ConsoleRoot from "./pages/Console";
import QuickStartCaller from "./pages/Docs/QuickStartCaller";
import QuickStartResponder from "./pages/Docs/QuickStartResponder";
import ProtocolExamplesPage from "./pages/Docs/ProtocolExamples";
import ProtocolArchitecturePage from "./pages/Docs/ProtocolArchitecture";
import DeployabilityProfilesPage from "./pages/Docs/DeployabilityProfiles";
import GlossaryPage from "./pages/Glossary";
import FaqPage from "./pages/Faq";
import TrustSettlementPage from "./pages/Pricing";
import VisionPage from "./pages/Vision";
import OpcPage from "./pages/Opc";
import MarketplaceRoadmapPage from "./pages/MarketplaceRoadmap";
import SearchPage from "./pages/Search";
import HotlineVsMcp from "./pages/Compare/HotlineVsMcp";
import HotlineVsSkills from "./pages/Compare/HotlineVsSkills";
import HotlineVsApi from "./pages/Compare/HotlineVsApi";
import HotlineVsSaas from "./pages/Compare/HotlineVsSaas";
import BlogIndex from "./pages/Blog";
import OpcAndHotlinePost from "./pages/Blog/2026-04-opc-and-hotline";
import EnglishHomePage from "./pages/en/Home";
import EnglishDocsPage from "./pages/en/Docs";
import EnglishQuickStartCaller from "./pages/en/Docs/QuickStartCaller";
import EnglishQuickStartResponder from "./pages/en/Docs/QuickStartResponder";
import EnglishProtocolExamplesPage from "./pages/en/Docs/ProtocolExamples";
import EnglishProtocolArchitecturePage from "./pages/en/Docs/ProtocolArchitecture";
import EnglishDeployabilityProfilesPage from "./pages/en/Docs/DeployabilityProfiles";
import CallerTeamLocalLoopCaseStudy from "./pages/en/CaseStudies/CallerTeamLocalLoop";
import ResponderOperatorFirstHotlineCaseStudy from "./pages/en/CaseStudies/ResponderOperatorFirstHotline";
import EnglishGlossaryPage from "./pages/en/Glossary";
import EnglishFaqPage from "./pages/en/Faq";
import EnglishTrustSettlementPage from "./pages/en/TrustSettlement";
import EnglishVisionPage from "./pages/en/Vision";
import EnglishOpcPage from "./pages/en/Opc";
import EnglishMarketplaceRoadmapPage from "./pages/en/MarketplaceRoadmap";
import EnglishSearchPage from "./pages/en/Search";
import EnglishHotlineVsMcp from "./pages/en/Compare/HotlineVsMcp";
import EnglishHotlineVsSkills from "./pages/en/Compare/HotlineVsSkills";
import EnglishHotlineVsApi from "./pages/en/Compare/HotlineVsApi";
import EnglishHotlineVsSaas from "./pages/en/Compare/HotlineVsSaas";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/playground" element={<Playground />} />
      <Route path="/marketplace/*" element={<Marketplace />} />
      <Route path="/docs/quick-start-caller" element={<QuickStartCaller />} />
      <Route path="/docs/quick-start-responder" element={<QuickStartResponder />} />
      <Route path="/docs/protocol-examples" element={<ProtocolExamplesPage />} />
      <Route path="/docs/protocol-architecture" element={<ProtocolArchitecturePage />} />
      <Route path="/docs/deployability-profiles" element={<DeployabilityProfilesPage />} />
      <Route path="/docs/*" element={<Docs />} />
      <Route path="/console/*" element={<ConsoleRoot />} />
      {/* Phase 2 GEO content routes */}
      <Route path="/glossary" element={<GlossaryPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/trust-settlement" element={<TrustSettlementPage />} />
      <Route path="/vision" element={<VisionPage />} />
      <Route path="/opc" element={<OpcPage />} />
      <Route path="/marketplace-roadmap" element={<MarketplaceRoadmapPage />} />
      {/* Redirects */}
      <Route path="/pricing" element={<Navigate to="/trust-settlement" replace />} />
      <Route path="/design-system" element={<Navigate to="/playground" replace />} />
      <Route path="/compare/hotline-vs-mcp" element={<HotlineVsMcp />} />
      <Route path="/compare/hotline-vs-skills" element={<HotlineVsSkills />} />
      <Route path="/compare/hotline-vs-api" element={<HotlineVsApi />} />
      <Route path="/compare/hotline-vs-saas" element={<HotlineVsSaas />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/2026-04-opc-and-hotline" element={<OpcAndHotlinePost />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/en" element={<EnglishHomePage />} />
      <Route path="/en/docs/quick-start-caller" element={<EnglishQuickStartCaller />} />
      <Route path="/en/docs/quick-start-responder" element={<EnglishQuickStartResponder />} />
      <Route path="/en/docs/protocol-examples" element={<EnglishProtocolExamplesPage />} />
      <Route path="/en/docs/protocol-architecture" element={<EnglishProtocolArchitecturePage />} />
      <Route path="/en/docs/deployability-profiles" element={<EnglishDeployabilityProfilesPage />} />
      <Route path="/en/case-studies/caller-team-local-loop" element={<CallerTeamLocalLoopCaseStudy />} />
      <Route path="/en/case-studies/responder-operator-first-hotline" element={<ResponderOperatorFirstHotlineCaseStudy />} />
      <Route path="/en/docs" element={<EnglishDocsPage />} />
      <Route path="/en/glossary" element={<EnglishGlossaryPage />} />
      <Route path="/en/faq" element={<EnglishFaqPage />} />
      <Route path="/en/search" element={<EnglishSearchPage />} />
      <Route path="/en/compare/hotline-vs-mcp" element={<EnglishHotlineVsMcp />} />
      <Route path="/en/compare/hotline-vs-skills" element={<EnglishHotlineVsSkills />} />
      <Route path="/en/compare/hotline-vs-api" element={<EnglishHotlineVsApi />} />
      <Route path="/en/compare/hotline-vs-saas" element={<EnglishHotlineVsSaas />} />
      {/* English new pages */}
      <Route path="/en/trust-settlement" element={<EnglishTrustSettlementPage />} />
      <Route path="/en/vision" element={<EnglishVisionPage />} />
      <Route path="/en/opc" element={<EnglishOpcPage />} />
      <Route path="/en/marketplace-roadmap" element={<EnglishMarketplaceRoadmapPage />} />
    </Routes>
  );
}
